import React, { useState, useEffect } from 'react';
import { userService } from '../../_services';

/**
 * Claim Widget Component
 * Modernized - Displays claim counts (Total, Reversed, Net, Paid)
 */
function Claim({ data }) {
    const [claims, setClaims] = useState({
        total: '-',
        reversed: '-',
        net: '-',
        paid: '-'
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (data && data.type === "Claim") {
            fetchClaimData();
        }
    }, [data?.RequestJson]);

    const fetchClaimData = async () => {
        setLoading(true);
        try {
            // Use centralized service function
            const apidata = await userService.FetchWidgetData(
                data.url,
                JSON.parse(data.RequestJson),
                data.RequestJson1 || ''
            );

            if (apidata && apidata.length > 0 && apidata[0].legend) {
                setClaims({
                    total: apidata[0].legend[0]?.legendValue || '-',
                    reversed: apidata[0].legend[1]?.legendValue || '-',
                    net: apidata[0].legend[2]?.legendValue || '-',
                    paid: apidata[0].legend[3]?.legendValue || '-'
                });
            }
        } catch (error) {
            console.error('Error fetching claim data:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="bg-white rounded-lg p-6 shadow-sm animate-pulse">
                        <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
                        <div className="h-8 bg-gray-200 rounded w-16"></div>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <p className="text-md font-medium text-gray-60">Total Claims</p>
                <p className="text-3xl font-bold text-brand-dark mt-1">{claims.total}</p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <p className="text-md font-medium text-gray-600">Reversed Claims</p>
                <p className="text-3xl font-bold text-brand-dark mt-1">{claims.reversed}</p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <p className="text-md font-medium text-gray-600">Net Claims</p>
                <p className="text-3xl font-bold text-brand-dark mt-1">{claims.net}</p>
            </div>

            <div className="bg-white rounded-lg p-6 shadow-sm border border-gray-200">
                <p className="text-md font-medium text-gray-600">Paid Claims</p>
                <p className="text-3xl font-bold text-brand-dark mt-1">{claims.paid}</p>
            </div>
        </div>
    );
}

export default Claim;
